module.exports = __webpack_public_path__ + "static/media/ic-onaccount-blue.a6875439.svg";